import { render, staticRenderFns } from "./ConsumerForm.vue?vue&type=template&id=dfe23e14&scoped=true&"
import script from "./ConsumerForm.vue?vue&type=script&lang=js&"
export * from "./ConsumerForm.vue?vue&type=script&lang=js&"
import style0 from "./ConsumerForm.vue?vue&type=style&index=0&id=dfe23e14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.0_babel-co_0dbbf42f62185882c0604707ed980ddd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe23e14",
  null
  
)

export default component.exports